import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ModalNextContext } from '@jutro/components';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WMICLink } from 'wmic-pe-components-platform-react';

import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useWizardModals } from 'wmic-pe-portals-wizard-components-ui';
import { WMICErrorHandler } from 'wmic-pe-capability-quoteandbind-common-react';
import { parseErrorMessage, WMICLogger, WMICVariousUtil } from 'wmic-pe-portals-utils-js';
import WMICBrokerFeesModal from './WMICBrokerFeesModal/WMICBrokerFeesModal';
import messages from './WMICBrokerFeesComponent.messages';
import { TranslatorContext } from '@jutro/legacy/locale';

const WMICBrokerFeesComponent = ({ jobVM, updateJobVM }) => {
    const history = useHistory();
    const { showModal } = useContext(ModalNextContext);
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const { setWizardLoading } = useWizardModals();

    const onClickFn = async () => {
        try {
            await showModal(
                <WMICBrokerFeesModal
                    modalVM={jobVM}
                    viewModelService={viewModelService}
                    authHeader={authHeader}
                    setWizardLoading={setWizardLoading}
                    updateJobVM={updateJobVM}
                />
            );
        } catch (error) {
            WMICLogger.error('Error in Broker Fee handleRecalc', error);
            WMICErrorHandler.processAsModal(parseErrorMessage(error)).catch(() => history.push(WMICVariousUtil.getRedirectURLForJob(jobVM)));
        }
    };

    return (
        <WMICLink type="text" icon="mi-open-in-browser" className="gw-ml-5" onClick={onClickFn}>
            {translator(messages.brokerFees)}
        </WMICLink>
    );
};

export default WMICBrokerFeesComponent;
